const isDev = process.env.NODE_ENV === 'development';

export const log = (...args: unknown[]) => {
  if (isDev) console.warn('[app]', ...args);
};

export const warn = (...args: unknown[]) => {
  if (isDev) console.warn('[app]', ...args);
};

export const error = (...args: unknown[]) => {
  if (isDev) console.error('[app]', ...args);
};

export const logger = {
  log,
  warn,
  error,
};

export default logger;
